import React, { useState } from 'react';
import Modal from './index';
import FullOrderList from './components/FullOrderList';
import FlexOrderList from './components/FlexOrderList';
import SequentialOrderList from './components/SequentialOrderList';
import { getAuthHeaders, WORKER_URL } from '../../utils/api';

const OrdersModal = ({ isOpen, onClose, orders, type }) => {
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [processStatus, setProcessStatus] = useState('');
    const [currentFilter, setCurrentFilter] = useState('needsInvoice');

    const handleGenerateLabels = async (selectedIds) => {
        try {
            setIsLoading(true);
            const labelFormat = localStorage.getItem('label_format') || 'pdf';
            for (const orderId of selectedIds) {
                try {
                    const res = await fetch(`${WORKER_URL}/api/labels/generate/${orderId}`, {
                        method: 'POST',
                        headers: { ...getAuthHeaders(), 'x-label-format': labelFormat }
                    });
                    if (!res.ok) throw new Error('Erro ao gerar etiqueta');
                    const blob = await res.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `etiqueta-${orderId}.${labelFormat === 'zpl' ? 'txt' : 'pdf'}`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    setProcessStatus(`Erro ao gerar etiqueta: ${error.message}`);
                }
            }
            window.location.reload();
        } catch (error) {
            setProcessStatus('Erro ao gerar etiquetas');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelectOrder = (orderId) => {
        setSelectedOrders(prev => prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]);
    };

    const handleSelectAll = (orders) => {
        setSelectedOrders(prev => prev.length === orders.length ? [] : orders.map(o => o.id));
    };

    const handleGenerateInvoices = async (selectedIds) => {
        try {
            setIsLoading(true);
            for (const orderId of selectedIds) {
                await fetch(`${WORKER_URL}/api/invoices/issue/${orderId}`, {
                    method: 'POST',
                    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' }
                });
                const statusRes = await fetch(`${WORKER_URL}/api/orders/${orderId}/status`, { headers: getAuthHeaders() });
                const statusData = await statusRes.json();
                if (!statusData.hasInvoice) throw new Error('Nota fiscal não emitida');
            }
            setCurrentFilter('needsLabel');
            setSelectedOrders([]);
            window.location.reload();
        } catch (error) {
            setProcessStatus('Erro ao emitir nota fiscal.');
        } finally {
            setIsLoading(false);
        }
    };

    const renderModalContent = () => {
        const commonProps = {
            orders, selectedOrders, onSelectOrder: handleSelectOrder, onSelectAll: handleSelectAll,
            currentFilter, onFilterChange: setCurrentFilter, isLoading, processStatus
        };
        switch (type) {
            case 'full': return <FullOrderList {...commonProps} />;
            case 'flex': return <FlexOrderList {...commonProps} onGenerateInvoices={handleGenerateInvoices} onGenerateLabels={handleGenerateLabels} />;
            case 'agency':
            case 'withdrawal': return <SequentialOrderList {...commonProps} type={type} onGenerateInvoices={handleGenerateInvoices} onGenerateLabels={handleGenerateLabels} />;
            default: return null;
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Pedidos ${type?.toUpperCase()}`}>
            {renderModalContent()}
        </Modal>
    );
};

export default OrdersModal;
